import { useEffect, useState } from "react";
import styles from "./ScrollToTopButton.module.scss";

const goToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const ScrollToTopButton = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const buttonVisibilityHandler = () => {
      if (window.scrollY > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };

    window.addEventListener("scroll", buttonVisibilityHandler);

    return () => window.removeEventListener("scroll", buttonVisibilityHandler);
  }, []);

  return (
    <>
      {showTopBtn && (
        <button className={styles.button} onClick={goToTop}>
          <img src='/assets/arrowTop.svg' alt='arrowTop' />
        </button>
      )}
    </>
  );
};
